import { Component } from '@angular/core'
import { ScreenSpinnerComponent } from '../../../shared'

@Component({
  selector: 'app-loading',
  imports: [ScreenSpinnerComponent],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  standalone: true
})
export class LoadingComponent {}
